export default {
  "--main-background": "#141A27",
  "--background-normal": "#141A27",
};
